import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import type { FC } from "react";

import { LifetimePremiumContent } from "~/feature/getUpdates/components/LifetimePremiumContent";

import * as Styled from "./GetUpdatesSheet.styles";

interface IGetUpdatesSheetProps {
  open: boolean;
  onClose: () => void;
}

export const GetUpdatesSheet: FC<IGetUpdatesSheetProps> = ({
  open,
  onClose,
}) => {
  return (
    <Styled.Sheet
      anchor="bottom"
      open={open}
      onOpen={() => undefined}
      onClose={onClose}
      disableSwipeToOpen
      ModalProps={{ keepMounted: false }}
    >
      <Styled.Puller />
      <Styled.CloseButton aria-label="Close" size="small" onClick={onClose}>
        <CloseRoundedIcon />
      </Styled.CloseButton>
      <LifetimePremiumContent onClose={onClose} />
    </Styled.Sheet>
  );
};
